import {
    DateTimeFormatter as DTF,
    Duration as Dur,
    Instant as Inst,
    LocalDate as LD,
    LocalDateTime as LDT,
    LocalTime as LT
} from "@js-joda/core";

const createParser = <T, U>( parseFunc: ( input: T ) => U ) => {
    function parser( input: T ): U;
    function parser( input: null ): null;
    function parser( input: T | null ): U | null;
    function parser( input: T | null ): U | null {
        if( input === null ) return null;
        return parseFunc( input );
    }
    return parser;
};

const createEmitter = <T, U>( emitFunc: ( input: T ) => U ) => {
    function emitter( input: T ): U;
    function emitter( input: null ): null;
    function emitter( input: T | null ): U | null;
    function emitter( input: T | null ): U | null {
        if( input === null ) return null;
        return emitFunc( input );
    }
    return emitter;
};

// Parsers using factory pattern
export const parseLocalDate = createParser( ( s: string ) =>
    LD.parse( s, DTF.ISO_LOCAL_DATE )
);

export const parseLocalDateTime = createParser( ( s: string ) =>
    LDT.parse( s, DTF.ISO_LOCAL_DATE_TIME )
);

export const parseLocalTime = createParser( ( s: string ) =>
    LT.parse( s, DTF.ISO_LOCAL_TIME )
);

export const parseDuration = createParser( ( m: number ) =>
    Dur.ofMinutes( m )
);

export const parseInstant = createParser( ( s: string ) =>
    Inst.parse( s )
);

// Emitters using factory pattern
export const emitLocalDate = createEmitter( ( d: LD ) =>
    d.format( DTF.ISO_LOCAL_DATE )
);

export const emitLocalDateTime = createEmitter( ( dt: LDT ) =>
    dt.format( DTF.ISO_LOCAL_DATE_TIME )
);

export const emitLocalTime = createEmitter( ( t: LT ) =>
    t.format( DTF.ISO_LOCAL_TIME )
);

export const emitDuration = createEmitter( ( d: Dur ) =>
    d.toMinutes()
);

export const emitInstant = createEmitter( ( i: Inst ) =>
    i.toString()
);